import { render, staticRenderFns } from "./VenueQuestionLimitModal.vue?vue&type=template&id=f85f8c32&"
import script from "./VenueQuestionLimitModal.vue?vue&type=script&lang=ts&"
export * from "./VenueQuestionLimitModal.vue?vue&type=script&lang=ts&"
import style0 from "./VenueQuestionLimitModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports